var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { School, SchoolIncludes } from '@/models/School';
import { avatarHtml } from '@/support/String';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import CreateDialog from '@/views/School/CreateDialog';
import ErrorHandler from '@/support/ErrorHandler';
import { RolesEnum } from '@/items/Roles';
import { DownloadTeacher } from '@/models/DownloadTeacher';
import { Token } from '@/support/Token';
import { GlobalUser } from '@/models/GlobalUser';
let Schools = class Schools extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Schools';
        this.selected = [];
        this.selectedSchool = null;
        this.isShowingDialog = false;
        this.isDisplayingNewSchoolDialog = false;
    }
    async onClickDownloadTeachersData() {
        const schools = this.selected.map((selectedSchool) => selectedSchool.id);
        const response = await new DownloadTeacher().create({ schools }).catch((error) => {
            ErrorHandler.alert(this.$tc('download_teacher_error_text'), this.$tc('download_teacher_error_title'), 'warning');
        });
        this.selected = [];
        window.open(response.data.url, '_blank');
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    async onClickSwitchTenant(school) {
        await new GlobalUser().authenticate();
        const token = Token.get();
        window.open(`${school.links.web}/school-settings/${school.id}?token=${token}`, '_self');
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('school.title', 1),
                plural: this.$tc('school.title', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                {
                    text: this.$tc('name.title'),
                    value: 'name',
                    width: '20%',
                },
                {
                    text: 'URL',
                    value: 'links',
                    transform: (current) => {
                        return `<a href="${current.web}">${current.web}</a>`;
                    },
                    width: '50%',
                },
                {
                    text: this.$tc('group.amountOfStudents'),
                    value: 'amount_of_students',
                    width: '10%',
                    class: 'align-text-right',
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: (vm, school) => {
                        this.onClickSwitchTenant(school);
                    },
                },
                ...(this.isDeleteIconVisible
                    ? [
                        {
                            type: 'delete',
                            label: 'delete',
                            icon: 'delete',
                            action: (vm, school) => {
                                this.selectedSchool = school;
                                this.$store.dispatch('openDialog', this.dialogOptions);
                            },
                        },
                    ]
                    : []),
            ],
            filters: [],
            model: new School().include(SchoolIncludes.AMOUNT_OF_STUDENTS),
        };
    }
    get dialogOptions() {
        const school = this.selectedSchool;
        return {
            title: school.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, { item: this.$t('dialogOptions.item.school') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!school) {
                            return;
                        }
                        school
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedSchool = new School();
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedSchool = new School();
                    },
                },
            },
        };
    }
    get canCreate() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT]);
    }
    get isDeleteIconVisible() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN]);
    }
};
Schools = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            CreateDialog,
        },
    })
], Schools);
export default Schools;
